import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import Name from './Name'
import Price from './Price'
import Variation from './Variation'
import get from 'lodash/get'

export default class Mobile extends React.Component {
  static propTypes = {
    markets: PropTypes.array,
    renderArrows: PropTypes.func,
    selectMarket: PropTypes.func
  }
  renderMarkets() {
    let position = 0
    return this.props.markets.map(
      ({code, name, currentStats, lastTrade, mainCurrency, secondaryCurrency}) => {
        position = position + 60
        return (
          <div
            key={name}
            style={{top: position - 50}}
            className={`${styles.market} row`}
            onClick={event => this.props.selectMarket(event, code)}>
            <Name mainCurrency={mainCurrency} marketCode={name} />
            <Price lastTrade={lastTrade} secondaryCurrency={secondaryCurrency} />
            <Variation amount={get(currentStats, 'variation', 0)} />
          </div>
        )
      }
    )
  }
  render() {
    return <div className={styles.container}>{this.renderMarkets()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Mobile/index.js